import { render, staticRenderFns } from "./TerrenoPreca.vue?vue&type=template&id=2fdef9d1&scoped=true&lang=html&"
import script from "./TerrenoPreca.vue?vue&type=script&lang=js&"
export * from "./TerrenoPreca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdef9d1",
  null
  
)

export default component.exports